var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructThumbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 28",
    style: {
      enableBackground: "new 0 0 32 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    className: "st0",
    d: "M2,10h4c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V12C0,10.9,0.9,10,2,10  M19.5,0.1c1.6,0.3,2.7,1.9,2.3,3.5c0,0,0,0,0,0l-0.1,0.7C21.4,6,20.8,7.5,19.9,9h9c1.7-0.1,3,1.2,3.1,2.9 c0.1,1.7-1.2,3.1-2.9,3.1l0,0c1.1,1.2,1,3.1-0.2,4.2c-0.4,0.4-0.9,0.6-1.4,0.7c0.9,1.4,0.4,3.3-1,4.1c-0.2,0.1-0.4,0.2-0.6,0.3 c0,0.2,0.1,0.4,0.1,0.6c0,1.7-1.3,3-3,3h-4.6c-1.2,0-2.3-0.3-3.3-1l-2.4-1.6c-1.7-1.1-2.7-3-2.7-5v-7c0-1.8,0.8-3.5,2.2-4.7 l0.5-0.4c1.6-1.3,2.8-3.2,3.2-5.3L16,2.4C16.3,0.8,17.9-0.3,19.5,0.1C19.5,0.1,19.5,0.1,19.5,0.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructThumbIcon);
export default __webpack_public_path__ + "static/media/Instruct_Thumb_icon.6a5e90f15ffe39c549d2fc3c122494ea.svg";
export { ForwardRef as ReactComponent };